module.exports = {"data":{"allMarkdownRemark":null},"pathContext":{"author":"/people/jack-davey/"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/authors-jack-davey.json
// module id = 1605
// module chunks = 256103571735664